import _axios from '../../apiClient';

export function GetLocalidadesEntregaActivas() {
    return _axios
        .get(`/api/LocalidadEntrega/GetLocalidadesEntregaActivas`, {
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log('Error en la petición de localidades entrega activas', error);
            const data = error.response.data;
            throw data;
        });
}

export function GetLocalidadEntrega(idLocalidadEntrega) {
    return _axios
        .get(`/api/LocalidadEntrega/GetLocalidadEntrega/${idLocalidadEntrega}`, {
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log('Error en la petición de localidad entrega por ID', error);
            const data = error.response.data;
            throw data;
        });
}
export function getDomiciliosSinLocalidadEntregaCliente(idCliente) {
  return _axios.get(`/api/LocalidadEntrega/VerificarDomiciliosSinLocalidad?idCliente=${idCliente}`, {
    responseType: 'json',
    headers: { 
      'Accept': 'application/json'
    }
  })
  .then(response => {
    return response.data;
  })
  .catch((error) => {
            console.log('Error al verificar domicilios sin localidad de entrega', error);
            const data = error.response.data;
            throw data;
        });
}

export function getDomicilioLocalidadPreferenciaEntregaCliente(idCliente) {
  return _axios.get(`/api/LocalidadEntrega/GetDomicilioEntregaPreferenciaCliente?idCliente=${idCliente}`, {
    responseType: 'json',
    headers: { 
      'Accept': 'application/json'
    }
  })
  .then(response => {
    return response.data.result;
  })
  .catch((error) => {
            console.log('Error al obtener localidad de entrega preferida', error);
            const data = error.response.data;
            throw data;
        });
}

export function updateLocalidadEntregaCliente(idDomicilioEntrega, idLocalidadEntrega) {
  return _axios.post(`/api/LocalidadEntrega/UpdateLocalidadEntrega`, 
    { 
      idDomicilioEntrega: idDomicilioEntrega,
      newIdLocalidadEntrega: idLocalidadEntrega
    },
    { 
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }
  )
  .then(response => {
    return response.data;
  })
  .catch((error) => {
            console.log('Error al actualizar localidad de entrega cliente', error);
            const data = error.response.data;
            throw data;
    });
}